/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink,Router} from '@angular/router';

import { Subscription } from 'rxjs/Subscription';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import {Meta, Title} from "@angular/platform-browser";
import {Observable}      from 'rxjs/Observable';
import {UserService} from "../../services/user.service";
declare let swal: any;
declare var $ : any;

declare var require: any;
declare let Instafeed: any;
declare var google: any;
declare var gapi: any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'calendar',
    templateUrl:'calendarcomponent.html',
    providers  : []
})
export class CalendarComponent implements OnInit {



    constructor(private _routeParams: ActivatedRoute ,
        private _router: Router ,private _companyService : CompanyService, public _appData : AppDataService,private _auth : UserService) {
    }

    public ngOnInit() : any {
        gapi.load('client:auth2', this.initClient);
    }

/**
 *  Initializes the API client library and sets up sign-in state
 *  listeners.
 */
public initClient() {
  var credentials = {
    apiKey: "AIzaSyBt_xy2toHw8Z31ItiZgPUnahcaHERfSr8",
    authDomain: "coolkids-669fa.firebaseapp.com",
    databaseURL: "https://coolkids-669fa.firebaseio.com",
    projectId: "coolkids-669fa",
    storageBucket: "coolkids-669fa.appspot.com",
    messagingSenderId: "159459566585"
  };

  gapi.client.init(credentials).then(function () {
    // Listen for sign-in state changes.
    gapi.auth2.getAuthInstance().isSignedIn.listen(updateSigninStatus);

    // Handle the initial sign-in state.
    this.updateSigninStatus(gapi.auth2.getAuthInstance().isSignedIn.get());
    var authorizeButton = document.getElementById('authorize_button');
    var signoutButton = document.getElementById('signout_button');
  }, function(error) {
    this.appendPre(JSON.stringify(error, null, 2));
  });

   /**
  *  Called when the signed in status changes, to update the UI
  *  appropriately. After a sign-in, the API is called.
  */
 function updateSigninStatus(isSignedIn) {
   if (isSignedIn) {
     //authorizeButton.style.display = 'none';
     //signoutButton.style.display = 'block';
     listUpcomingEvents();
   } else {
     //authorizeButton.style.display = 'block';
     //signoutButton.style.display = 'none';
   }
 }
 /**
 * Print the summary and start datetime/date of the next ten events in
 * the authorized user's calendar. If no events are found an
 * appropriate message is printed.
 */
 function listUpcomingEvents() {
  gapi.client.calendar.events.list({
        'calendarId': 'primary',
        'timeMin': (new Date()).toISOString(),
        'showDeleted': false,
        'singleEvents': true,
        'maxResults': 10,
        'orderBy': 'startTime'
      }).then(function(response) {
        var events = response.result.items;
        appendPre('Upcoming events:');

        if (events.length > 0) {
          for (let i = 0; i < events.length; i++) {
            var event = events[i];
            var when = event.start.dateTime;
            if (!when) {
              when = event.start.date;
            }
            appendPre(event.summary + ' (' + when + ')')
          }
        } else {
          appendPre('No upcoming events found.');
        }
      });
    }
    function appendPre(message) {
     var pre = document.getElementById('content');
     var textContent = document.createTextNode(message + '\n');
     pre.appendChild(textContent);
   }
}


/**
 *  Sign in the user upon button click.
 */
public handleAuthClick() {
  gapi.auth2.getAuthInstance().signIn();
}

/**
 *  Sign out the user upon button click.
 */
public handleSignoutClick() {
  gapi.auth2.getAuthInstance().signOut();
}






        
        




}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+integrationCode/calendar.component.ts